const URL_PREFIX = "https://brainhub.com.ph";   // No trailing slash!

export default {
  title: "Brainhub",
  localPrefix: 'bhub',
  // NB: URL prefixes below must not end with a slash!
  baseURL: `${URL_PREFIX}/api`,
  storageURL: `${URL_PREFIX}/storage`,
};
